// src/pages/JobDetail.jsx
import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchJobs } from "../../slice/jobSlice";

const JobDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { jobs, loading } = useSelector((state) => state.job);

  useEffect(() => {
    if (!jobs || jobs.length === 0) {
      dispatch(fetchJobs());
    }
  }, [dispatch, jobs]);

  const job = jobs.find((job) => String(job._id || job.id) === String(id));

  if (loading) {
    return <div className="p-10 text-center text-xl text-gray-600">Loading job details...</div>;
  }

  if (!job) {
    return <div className="p-10 text-center text-xl text-gray-600">Job not found.</div>;
  }

  return (
    <div className="max-w-5xl mx-auto px-6 py-14 bg-white text-gray-900">
      <div className="mb-6">
        <Link to="/job" className="text-sm text-[#345bf3] hover:underline">
          ← Back to Jobs
        </Link>
      </div>

      <div className="mb-10 border-b pb-6">
        <h1 className="text-4xl font-bold text-[#fc3c04] mb-2">{job.jobTitle}</h1>
        <p className="text-lg text-gray-600">{job.companyName} · {job.location}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-base mb-10">
        <div>
          <p className="font-semibold text-gray-700">Job Type</p>
          <p>{job.jobType}</p>
        </div>
        <div>
          <p className="font-semibold text-gray-700">Experience</p>
          <p>{job.experience}</p>
        </div>
        <div>
          <p className="font-semibold text-gray-700">Salary</p>
          <p>{job.salary || "Not specified"}</p>
        </div>
        <div>
          <p className="font-semibold text-gray-700">Location</p>
          <p>{job.location}</p>
        </div>
      </div>

      <div>
        <h2 className="text-2xl font-semibold text-[#345bf3] mb-3">Job Description</h2>
        <p className="text-gray-700 leading-relaxed text-justify">
          {job.description || "No description provided."}
        </p>
      </div>

      <div className="mt-10">
        <Link
          to="/apply-now"
          state={{ job_title: job.jobTitle }} // ✅ correct key
          onClick={() => localStorage.setItem("job_title", job.jobTitle)} // optional fallback
          className="inline-block bg-[#345bf3] text-white px-5 py-2 rounded hover:bg-[#fc3c04]  transition"
        >
          Apply Now
        </Link>
      </div>
    </div>
  );
};

export default JobDetail;
